import React, { ReactNode, useEffect } from 'react';
import { hoc } from 'lib';

import { observer } from 'mobx-react';
import PopupVideoWrap from 'client/pc/components/common/popup-video-wrap';
import { globalStore } from 'stores';
import { Wrap, Mask } from './styled';
import Icon from '../icon';

export {};

let _close: Function | null;

type IconType = '' | 'success' | 'fail' | 'loading' | 'info';

type IProps = {
  // 图标类型
  icon: IconType;
  duration: number;
  content: ReactNode;
  children: ReactNode;
  mask: boolean;
  autoClose: true;
  onClose: Function;
};

function Toast(props: IProps) {
  const {
    mask = false,
    content,
    icon,
    children,
    onClose,
    duration = 3000,
  } = props;

  const iconType = {
    success: 'check-line',
    fail: 'close-line',
    info: 'info-line',
    loading: 'shuaxin2',
  };

  const _onClose = () => {
    _close = null; // 如果已经自动执行了close,则把全局的关闭方法清掉
    if (icon !== 'loading') {
      onClose();
    }
  };

  useEffect(() => {
    let timerId;
    if (duration) {
      timerId = setTimeout(_onClose, duration);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [duration]);

  const isInPcClientRoom = globalStore.pageType === 'clientRoom';

  const body = (
    <Wrap className={isInPcClientRoom ? 'clientRoom' : ''}>
      <div className={`toast-bd ${icon}`} onClick={_onClose}>
        {icon && (
          <span className={`toast-icon ${icon}`}>
            <Icon type={iconType[icon]} />
          </span>
        )}
        <div className="toast-content">{children || content}</div>
      </div>
    </Wrap>
  );

  if (isInPcClientRoom) {
    return <PopupVideoWrap className="toast">{body}</PopupVideoWrap>;
  }

  if (mask || icon === 'loading') {
    return <Mask>{body}</Mask>;
  }

  return body;
}

namespace Toast {
  export const text = (
    content: ReactNode,
    onClose?: Function,
    duration?: number,
  ) => {
    return renderCom(content, onClose, duration);
  };

  // 失败
  export const fail = (
    content: ReactNode,
    onClose?: Function,
    duration?: number,
  ) => {
    return renderCom(content, onClose, duration, 'fail');
  };
  export const warn = fail;

  // 消息
  export const info = (
    content: ReactNode,
    onClose?: Function,
    duration?: number,
  ) => {
    return renderCom(content, onClose, duration, 'info');
  };

  export const success = (
    content: ReactNode,
    onClose?: Function,
    duration?: number,
  ) => {
    return renderCom(content, onClose, duration, 'success');
  };

  export const loading = (
    content: ReactNode,
    onClose?: Function,
    duration = 0,
  ) => {
    // loadingTimerId = setTimeout(() => {
    return renderCom(content, onClose, duration, 'loading');
    // }, 400);
    // return close;
  };

  export const close: Function = () => {
    _close && _close();
  };
}

// const Toast = Object.assign(ToastCom, {
//   // text,
//   fail,
//   warn,
//   success,
//   loading,
//   info,
//   close,
// });

type ShowFunc = (
  content: ReactNode | string,
  onClose?: Function,
  duration?: number,
  icon?: IconType,
) => Function;

const renderCom: ShowFunc = (content, onClose, duration = 3000, icon = '') => {
  _close && _close();

  const _onClose = () => {
    // clearTimeout(loadingTimerId);
    onClose && onClose();
  };
  console.log('toast', content);
  _close = hoc.render(
    {
      icon,
      content,
      duration,
      onClose: _onClose,
    },
    observer(Toast),
  );
  return _close!;
};

export default observer(Toast);
